<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<path d="M12,4V0H0v12h4v4h12V4H12z M1,11V1h10v3H4v7H1z M15,15H5v-3h7V5h3V15z" />
</svg>
</template>